import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../../app-insights";
import RootPage from "../RootPage";
import localisations from "shell/localisation";
import FieldCompanySelector from "shell/components/fieldCompany/FieldCompanySelector";

function SandboxPage() {
    return (
        <>
            <RootPage header={localisations.pages.sandbox.heading}></RootPage>
            <FieldCompanySelector></FieldCompanySelector>
        </>
    );
}

export default withAITracking(reactPlugin, SandboxPage, "Sandbox Page");
